<template functional>
  <nav
    v-bind="data.attrs"
    aria-label="Servicenavigation"
    class="footer-navigation"
  >
    <ul class="footer-navigation__list">

      <li class="footer-navigation__item">
        <a
          class="footer-navigation__link"
          href="https://www.claussen-simon-stiftung.de/de/legal/kontakt/"
          rel="noopener"
          target="_blank"
        >
          Kontaktformular
        </a>
      </li>

      <li class="footer-navigation__item">
        <a
          class="footer-navigation__link"
          href="https://www.claussen-simon-stiftung.de/de/aktuelles/newsletter/"
          rel="noopener"
          target="_blank"
        >
          Newsletter
        </a>
      </li>

      <li class="footer-navigation__item">
        <a
          class="footer-navigation__link"
          href="https://www.claussen-simon-stiftung.de/de/aktuelles/"
          rel="noopener"
          target="_blank"
        >
          Aktuelles
        </a>
      </li>

      <li class="footer-navigation__item">
        <a
          class="footer-navigation__link"
          href="https://www.claussen-simon-stiftung.de/de/stiftung/impressum/"
          rel="noopener"
          target="_blank"
        >
          Impressum & Datenschutz
        </a>
      </li>

    </ul>
  </nav>
</template>

<script>
export default {
  name: 'AFooterNavigation'
}
</script>

<style scoped>
.footer-navigation__list {
  list-style: none;

  margin: 0;
  padding: 0;
}

.footer-navigation__link {
  font-weight: 700;
  text-decoration: none;
}

.footer-navigation__link:hover {
  text-decoration: underline;
}
</style>
